import { render } from "./FormSelect.vue?vue&type=template&id=05b7dc62&scoped=true"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"

import "./FormSelect.vue?vue&type=style&index=0&id=05b7dc62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b7dc62"]])

export default __exports__